import WorkShowCase from "../../components/WorkShowCase";
import { GrDocumentPerformance } from "react-icons/gr";
import { AiOutlineAudit } from "react-icons/ai";
import { MdAnalytics } from "react-icons/md";
import { RiContractFill } from "react-icons/ri";
import { SiMicrostrategy } from "react-icons/si";

const services = [
  {
    icon: <GrDocumentPerformance />,
    title: "Practice Performance Analysis",
    desc: "We conduct in-depth financial and operational analysis of your practice to identify revenue gaps, billing inefficiencies, and opportunities for improved RCM performance.",
  },
  {
    icon: <RiContractFill />,
    title: "Contract Rate Optimization",
    desc: "We evaluate payer contracts and compare reimbursement rates with regional benchmarks to help healthcare providers secure fair and optimized payment structures.",
  },
  {
    icon: <SiMicrostrategy />,
    title: "Revenue Growth Strategy",
    desc: "Our experts design customized revenue growth strategies that help healthcare practices increase collections, reduce revenue leakage, and improve profitability.",
  },
  {
    icon: <AiOutlineAudit />,
    title: "Compliance & Audit Support",
    desc: "We ensure your practice stays compliant with healthcare regulations by providing audit-ready documentation, billing accuracy checks, and risk reduction strategies.",
  },
  {
    icon: <MdAnalytics />,
    title: "Healthcare Analytics & Reporting",
    desc: "We deliver clear, data-driven insights through advanced reporting and analytics to help providers make informed financial and operational decisions.",
  },
];

export default function Section7() {
  return (
    <WorkShowCase
      eyebrow="Work Showcase"
      heading="Healthcare Revenue Cycle Optimization & Practice Performance Solutions"
      description="Boost your healthcare practice’s financial performance with expert-driven revenue cycle management (RCM), contract optimization, compliance support, and advanced analytics."
      items={services}
    />
  );
}
